export const prettyEmptyValues = (value) => {
  if (value === null || value === undefined) {
    return '/'
  }
  return value
}
